import React, { useState, useRef, useEffect } from "react";
import {
  Typography,
  Box,
  IconButton,
  LinearProgress,
  Grid,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import CloseIcon from "@mui/icons-material/Close";
import UploadFileIcon from "@mui/icons-material/UploadFile";

const ALLOWED_FILE_TYPES = ["image/jpeg", "image/jpg", "image/png"];
const MAX_IMAGES = 1;

const useStyles = makeStyles((theme) => ({
  dropzone: {
    border: "2px dashed #ccc",
    textAlign: "center",
    cursor: "pointer",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: "#fff",
    transition: "background-color 0.3s, border-color 0.3s, border-style 0.3s",
    "&:hover": {
      borderColor: "#2196F3",
      backgroundColor: "#2196F314",
    },
    height: "120px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  dropzoneError: {
    border: "2px solid #D32F2F",
    backgroundColor: "#D32F2F0A",
    transition: "background-color 0.3s, border-color 0.3s, border-style 0.3s",
    "&:hover": {
      borderColor: "#2196F3",
      backgroundColor: "#2196F314",
    },
  },
  fileItem: {
    position: "relative",
    marginTop: theme.spacing(1),
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    border: "1px solid #ccc",
    backgroundColor: "#fff",
    overflow: "hidden", // Ensure overflow is hidden
  },
  errorMessage: {
    color: theme.palette.error.main,
  },
  fileIcon: {
    marginRight: theme.spacing(1),
    color: "#2196F3",
  },
  uploadIcon: {
    marginBottom: theme.spacing(1),
    color: "#2196F3",
  },
  imagePreview: {
    width: "50px", // Set width to 150px
    height: "50px", // Set height to 150px
    borderRadius: theme.shape.borderRadius, // Optional: to make the images have rounded corners
  },
  deleteButton: {
    position: "absolute",
    top: 5,
    right: 5,
    backgroundColor: "#fff", // Optional: to make the button stand out
    "&:hover": {
      backgroundColor: "#f44336", // Optional: hover effect for delete button
    },
  },
  fileName: {
    display: "block",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: "100%", // Make sure the filename container takes full width
  },
}));

const Dropzone = ({
  files,
  setFiles,
  setError,
  error,
  initialUrls,
  onDelete,
}) => {
  const classes = useStyles();
  const fileInputRef = useRef(null);
  const [isError, setIsError] = useState(false);

  // console.log("initialUrls", initialUrls);

  const formatFileSize = (bytes) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  };

  // useEffect(() => {
  //   if (initialUrls) {
  //     const urlFiles = initialUrls.map((url) => ({
  //       file: null,
  //       url: url.picture,
  //       id: url ? url.id : null,
  //       status: "complete",
  //     }));
  //     setFiles((prevFiles) => [...prevFiles, ...urlFiles]);
  //   }
  // }, [initialUrls, setFiles]);

  // const handleDrop = (event) => {
  //   event.preventDefault();
  //   const newFiles = Array.from(event.dataTransfer.files);
  //   const validFiles = newFiles.filter((file) =>
  //     ALLOWED_FILE_TYPES.includes(file.type)
  //   );

  //   if (validFiles.length !== newFiles.length) {
  //     setError("Only JPG, JPEG, or PNG files are allowed.");
  //     setIsError(true);
  //   } else {
  //     setError(null);
  //     setIsError(false);
  //     handleFiles(validFiles);
  //   }
  // };

  // const handleInputChange = (event) => {
  //   const newFiles = Array.from(event.target.files);
  //   const validFiles = newFiles.filter((file) =>
  //     ALLOWED_FILE_TYPES.includes(file.type)
  //   );

  //   if (validFiles.length !== newFiles.length) {
  //     setError("Only JPG, JPEG, or PNG files are allowed.");
  //     setIsError(true);
  //   } else {
  //     setError(null);
  //     setIsError(false);
  //     handleFiles(validFiles);
  //   }
  // };

  // const handleFiles = (newFiles) => {
  //   const totalFiles = files.length + newFiles.length;

  //   if (totalFiles > MAX_IMAGES) {
  //     setError(`You can only upload a maximum of ${MAX_IMAGES} images.`);
  //     setIsError(true);
  //     return;
  //   }

  //   const updatedFiles = [...files];
  //   let hasError = false;

  //   newFiles.forEach((file) => {
  //     if (file.size <= 3 * 1024 * 1024) {
  //       updatedFiles.push({ file, status: "loading", progress: 0 });
  //       simulateUpload(file, updatedFiles.length - 1);
  //     } else {
  //       setError("File too large");
  //       hasError = true;
  //     }
  //   });

  //   if (!hasError) {
  //     setError(null);
  //   }

  //   setFiles(updatedFiles);
  // };

  // const simulateUpload = (file, index) => {
  //   const interval = setInterval(() => {
  //     setFiles((prevFiles) => {
  //       const updatedFiles = [...prevFiles];
  //       if (updatedFiles[index].progress < 100) {
  //         updatedFiles[index].progress += 10;
  //       } else {
  //         updatedFiles[index].status = "complete";
  //         clearInterval(interval);
  //         console.log("File uploaded:", file.name); // Log when the upload is complete
  //       }
  //       return updatedFiles;
  //     });
  //   }, 200);
  // };

  // const handleDelete = (index) => {
  //   setFiles((prevFiles) => {
  //     const fileToDelete = prevFiles[index];
  //     if (fileToDelete.url && fileToDelete.id) {
  //       // If the file is from initialUrls and has an ID
  //       onDelete((prevIds) => [...prevIds, fileToDelete.id]);
  //     }
  //     return prevFiles.filter((_, i) => i !== index);
  //   });
  // };

  ///////////////////////////////////////////////\\\\\\\\\\\\\

  useEffect(() => {
    if (initialUrls) {
      const urlFiles = initialUrls.map((url) => ({
        file: null,
        url: url.picture,
        id: url.id,
        status: "complete",
      }));
      setFiles((prevFiles) => {
        const newFiles = urlFiles.filter(
          (newFile) => !prevFiles.some((file) => file.url === newFile.url) // Ensure no duplicates
        );
        return [...prevFiles, ...newFiles];
      });
    }
  }, [initialUrls, setFiles]);

  // Handle drag-and-drop file upload
  const handleDrop = (event) => {
    event.preventDefault();
    const newFiles = Array.from(event.dataTransfer.files);
    const validFiles = validateFiles(newFiles);
    if (validFiles) handleFiles(validFiles);
  };

  // Handle file input change
  const handleInputChange = (event) => {
    const newFiles = Array.from(event.target.files);
    const validFiles = validateFiles(newFiles);
    if (validFiles) handleFiles(validFiles);

    event.target.value = ""; // Reset the input value to allow re-uploading the same file
  };

  // Validate files for type and size
  const validateFiles = (newFiles) => {
    const validFiles = newFiles.filter((file) =>
      ALLOWED_FILE_TYPES.includes(file.type)
    );
    if (validFiles.length !== newFiles.length) {
      setError("Only JPG, JPEG, or PNG files are allowed.");
      setIsError(true);
      return null;
    } else if (files.length + validFiles.length > MAX_IMAGES) {
      setError(`You can only upload a maximum of ${MAX_IMAGES} images.`);
      setIsError(true);
      return null;
    } else if (
      validFiles.filter((file) => file.size > 3 * 1024 * 1024).length > 0
    ) {
      setError("Each file must not exceed 3 MB.");
      setIsError(true);
      return null;
    } else {
      setError(null);
      setIsError(false);
      return validFiles;
    }
  };

  // Add new files and simulate upload
  const handleFiles = (newFiles) => {
    const updatedFiles = [...files];

    newFiles.forEach((file) => {
      const blobUrl = URL.createObjectURL(file); // Create Blob URL
      updatedFiles.push({
        file,
        url: blobUrl,
        status: "loading",
        progress: 0,
      });
      simulateUpload(file, updatedFiles.length - 1);
    });

    setFiles(updatedFiles);
  };

  // Simulate file upload progress
  const simulateUpload = (file, index) => {
    let progress = 0;
    const interval = setInterval(() => {
      progress += 10;
      if (progress < 100) {
        setFiles(
          (prevFiles) =>
            prevFiles.map((f, i) => (i === index ? { ...f, progress } : f)) // Update progress
        );
      } else {
        clearInterval(interval);
        setFiles((prevFiles) =>
          prevFiles.map((f, i) =>
            i === index ? { ...f, status: "complete", progress: 100 } : f
          )
        );
        console.log("File uploaded:", file.name);
      }
    }, 200);
  };

  // Delete file and revoke Blob URL if applicable
  const handleDelete = (index) => {
    setFiles((prevFiles) => {
      const fileToDelete = prevFiles[index];
      if (fileToDelete.url) {
        URL.revokeObjectURL(fileToDelete.url); // Revoke Blob URL
      }
      if (fileToDelete.url && fileToDelete.id) {
        onDelete((prevIds) => [...prevIds, fileToDelete.id]);
      }
      return prevFiles.filter((_, i) => i !== index);
    });
  };

  return (
    <>
      <Box
        className={`${classes.dropzone} ${
          isError ? classes.dropzoneError : ""
        }`}
        onDrop={handleDrop}
        onDragOver={(e) => e.preventDefault()}
        onClick={() => fileInputRef.current.click()}
      >
        <UploadFileIcon className={classes.uploadIcon} fontSize="large" />

        <Typography variant="body2">
          <span style={{ textDecoration: "underline", color: "#2196F3" }}>
            เลือกไฟล์
          </span>{" "}
          หรือ ลากแล้วปล่อยไฟล์
        </Typography>
        <Typography variant="body2" color="textSecondary">
          PNG, JPG or JPEG (สูงสุด 3MB)
        </Typography>
        <input
          ref={fileInputRef}
          type="file"
          style={{ display: "none" }}
          onChange={handleInputChange}
          multiple
          accept=".jpg,.jpeg,.png"
        />
      </Box>

      <Grid container spacing={1} sx={{ mt: 1 }}>
        {(files || []).map((fileObj, index) => (
          <Grid item xs={12} sm={12} md={12} lg={12} key={index}>
            <Box
              className={classes.fileItem}
              display={"flex"}
              alignItems={"center"}
            >
              {fileObj.url ? (
                <img
                  src={fileObj.url}
                  alt="Preview"
                  className={classes.imagePreview}
                />
              ) : fileObj?.file instanceof File ? (
                <img
                  src={URL.createObjectURL(fileObj.file)}
                  alt="Preview"
                  className={classes.imagePreview}
                />
              ) : (
                <Box
                  sx={{
                    width: 50,
                    height: 50,
                    borderRadius: 1,
                    backgroundColor: "#f0f0f0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#999",
                    fontSize: 12,
                  }}
                >
                  ไม่มีรูปภาพ
                </Box>
              )}{" "}
              <Box sx={{ ml: 1 }}>
                {fileObj.file ? fileObj.file.name : "Existing Image"}
                <Typography variant="body2" className={classes.fileName}>
                  {formatFileSize(fileObj.file?.size)}
                  {fileObj.status === "complete" && " • Complete"}
                  {fileObj.status === "loading" && (
                    <LinearProgress
                      variant="determinate"
                      value={fileObj.progress}
                      sx={{
                        borderRadius: 10,
                      }}
                    />
                  )}
                </Typography>
              </Box>
              {fileObj.status !== "loading" ? (
                <IconButton
                  size="small"
                  onClick={() => handleDelete(index)}
                  className={classes.deleteButton}
                  id="delete-button"
                >
                  <CloseIcon />
                </IconButton>
              ) : null}
            </Box>
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default Dropzone;
